import { render, staticRenderFns } from "./CreateOrder.vue?vue&type=template&id=14116210&scoped=true"
import script from "./CreateOrder.vue?vue&type=script&lang=js"
export * from "./CreateOrder.vue?vue&type=script&lang=js"
import style0 from "./CreateOrder.vue?vue&type=style&index=0&id=14116210&prod&lang=scss&scoped=true"
import style1 from "./CreateOrder.vue?vue&type=style&index=1&id=14116210&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14116210",
  null
  
)

export default component.exports